import { useRouter } from "next/router";
import { useCallback, useState } from "react";

const extractQueryParam = (queryParam: string | string[] | undefined): string | undefined => {
  let extractedParam: string | undefined;
  if (Array.isArray(queryParam)) {
    extractedParam = queryParam[0];
  } else {
    extractedParam = queryParam;
  }

  return extractedParam;
};

const isValidTab = <T extends Record<string, number>>(
  tabs: T,
  tab: string,
): tab is Extract<keyof T, string> => {
  return tab in tabs;
};

const keyFromValue = <T extends Record<string, number>>(
  obj: T,
  value: T[keyof T],
): Extract<keyof T, string> | undefined => {
  for (const a in obj) {
    if (obj[a] === value) {
      return a;
    }
  }
};

export const useTab = <T extends Record<string, number>>(
  tabs: T,
  defaultTab?: Extract<keyof T, string>,
) => {
  const router = useRouter();
  const tab = extractQueryParam(router.query.tab);

  const defaultTabKey = defaultTab ?? Object.keys(tabs)[0];

  const baseTab = tab && isValidTab(tabs, tab) ? tabs[tab] : tabs[defaultTabKey];
  const [selectedTab, setSelectedTab] = useState(baseTab);

  const onSelectTab = useCallback(
    (index: T[keyof T]) => {
      setSelectedTab(index);
      const tab = keyFromValue(tabs, index);
      router.query.tab = tab;
      router.push(router);
    },
    [router, tabs],
  );

  return { selectedTab, onSelectTab };
};
